'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contractDetailInfoComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var contractDetailInfoComponent = exports.contractDetailInfoComponent = {
    template: require('./contract-detail-info.html'),
    bindings: {
        contract: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "config", "authService", "$stateParams", function contractDetailInfoController(common, config, authService, $stateParams) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$stateParams = $stateParams;
        vm.getDownloadUrl = getDownloadUrlContractProductsDetail;
        vm.startDateIsValid = startDateIsValid;
        vm.getDownloadUrlContractDetail = getDownloadUrlContractDetail;
        vm.from = (0, _moment2.default)(vm.contract.startDate).toISOString();
        if (vm.contract.portalContractTypeCode === 'FEB') {
            vm.minFrom = (0, _moment2.default)(vm.contract.startDate).toISOString();
        }
        vm.to = (0, _moment2.default)(vm.contract.endDate).toISOString();
        vm.checkYearsApart = checkYearsApart;

        function init() {
            common.navigationMenu.clearActiveMenu();
            vm.contract.description = (0, _marked2.default)(vm.contract.description || '');
        }

        function getDownloadUrlContractProductsDetail() {

            if (vm.contract.agiosNr === 'F001' || vm.contract.agiosNr === 'A005') {
                if (!vm.startDateIsValid()) return null;
                return config.webApiBaseUrl + ('report/febelCareProductsDetail/' + vm.contract.id + '?from=' + (0, _moment2.default)(vm.from).toISOString() + '&to=' + (0, _moment2.default)(vm.to).toISOString() + '&lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken);
            } else {
                return config.webApiBaseUrl + ('report/agiosProductsDetail/' + vm.contract.id + '?from=' + (0, _moment2.default)(vm.from).toISOString() + '&to=' + (0, _moment2.default)(vm.to).toISOString() + '&lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken);
            }
        }

        function startDateIsValid() {
            return !!vm.from;
        }

        function getDownloadUrlContractDetail() {
            return config.webApiBaseUrl + ('report/agiosContractDetail/' + vm.contract.id + '?lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken);
        }

        function checkYearsApart() {
            return (0, _moment2.default)(vm.contract.endDate).format('YYYY') - (0, _moment2.default)(vm.contract.startDate).format('YYYY') > 10 ? true : false;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/components/contract-detail-info.js
// module id = 835
// module chunks = 0